// eslint-disable-next-line import/prefer-default-export
export const templateNames = ['Default', 'Editorial', 'KPE'] as const;

import * as textColors from '@klaviyo-mkt/design-system/dist/typescript/text-colors';

// Helper function to get background color names from text color names
const getBackgroundColorNames = (textColorEntries: [string, string][]) => {
  return textColorEntries
    .map(([textColorName]) => {
      // Remove "Text" suffix (e.g., "charcoalText" -> "charcoal")
      const backgroundColorName = textColorName.replace(/Text$/, '');
      return backgroundColorName;
    })
    .filter(Boolean);
};

// Get all text color entries
const textColorEntries = Object.entries(textColors) as [string, string][];

// Colors that have white text (dark backgrounds)
const whiteTextColors = textColorEntries.filter(([, value]) => value === 'rgb(255, 255, 255)');
export const DARK_BACKGROUNDS = [
  ...getBackgroundColorNames(whiteTextColors),
  // Keep legacy gradient colors that aren't in design system
  'lakePoppy', 'lemonPoppy', 'sagePoppy', 'lavenderPoppy', 'sage'
];

// Colors that have charcoal text (light backgrounds)  
const charcoalTextColors = textColorEntries.filter(([, value]) => value === 'rgb(35, 33, 33)');
export const LIGHT_BACKGROUNDS = [
  ...getBackgroundColorNames(charcoalTextColors),
  // Keep legacy gradient colors that aren't in design system
  'lightSandPoppy'
];

export const BACKGROUND_GRADIENTS = ['lakePoppy', 'lemonPoppy', 'sagePoppy', 'lavenderPoppy', 'lightSandPoppy'];
